export enum TranslateLoadingState {
    Waiting,
    Loading,
    Done
}
